import { TFunction } from '@lyearn/i18n';
import { ResourceResponseTypeEnum, ResourceReviewTypeEnum } from '@/types/schema';

import { getResponseTypeSmallIcon } from '../../../helpers/getResponseTypeIcon';

const getLabel = (t: TFunction, responseType: string) =>
  t('Exercise:Creator.ResponseType', { responseType });

export const getSubmissionFormats = (t: TFunction) => [
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Any),
    label: getLabel(t, t('Exercise:Creator.AnyFormat')),
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Text)!,
    label: getLabel(t, t('Exercise:Creator.TextEntry')),
    value: ResourceResponseTypeEnum.Text,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Image)!,
    label: getLabel(t, t('Exercise:Creator.Image')),
    value: ResourceResponseTypeEnum.Image,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Video)!,
    label: getLabel(t, t('Exercise:Creator.VideoRecording')),
    value: ResourceResponseTypeEnum.Video,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Audio)!,
    label: getLabel(t, t('Exercise:Creator.Audio')),
    value: ResourceResponseTypeEnum.Audio,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.File)!,
    label: getLabel(t, t('Exercise:Creator.File')),
    value: ResourceResponseTypeEnum.File,
  },
];

export const REVIEW_OPTION_LABEL_i18_KEY = {
  [ResourceReviewTypeEnum.MandatoryReview]: 'Exercise:Creator.MandatoryReview',
  [ResourceReviewTypeEnum.OptionalReview]: 'Exercise:Creator.OptionalReview',
  [ResourceReviewTypeEnum.NoReview]: 'Exercise:Creator.NoReview',
};

export const getReviewOptions = (t: TFunction) => [
  {
    label: t(REVIEW_OPTION_LABEL_i18_KEY[ResourceReviewTypeEnum.MandatoryReview]),
    value: ResourceReviewTypeEnum.MandatoryReview,
  },
  {
    label: t(REVIEW_OPTION_LABEL_i18_KEY[ResourceReviewTypeEnum.OptionalReview]),
    value: ResourceReviewTypeEnum.OptionalReview,
  },
  {
    label: t(REVIEW_OPTION_LABEL_i18_KEY[ResourceReviewTypeEnum.NoReview]),
    value: ResourceReviewTypeEnum.NoReview,
  },
];
